import { parsePhoneNumber, AsYouType } from 'libphonenumber-js'; // https://github.com/catamphetamine/libphonenumber-js
import { format, parseISO, differenceInYears, differenceInMonths, formatDistanceToNowStrict } from "date-fns";

export const USDollar = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
});

export const formatUSD = (value) => {
    if (isNaN(value)) {
        return "$0";
    }
    let formatted = USDollar.format(value);
    return formatted;
}

export const formatPhoneNumber = (value) => {
  try {
    if (value === "") {
      return "";
    }
    const phoneNumber = parsePhoneNumber(value, 'US');
    if (phoneNumber) {
      return phoneNumber.formatNational();
    } else {
      return "";
    }
  }
  catch {
    return "";
  }
}

export const formatPhoneNumberUri = (value) => {
    if (value === "") {
        return "";
    }
    const phoneNumber = parsePhoneNumber(value, 'US');
    if (phoneNumber) {
        return phoneNumber.getURI();
    } else {
        return "";
    }
}

export const formatPhoneNumberAsYouType = (value) => {
  var tempPhone = value;
  tempPhone = formatPhoneFromNonIntegers(tempPhone);
  var formattedPhoneNumber = new AsYouType('US').input(tempPhone);
 // console.log("formattedPhoneNumber",formattedPhoneNumber);
  //Check if last character is )
  if (formattedPhoneNumber[formattedPhoneNumber.length - 1] === ")")
  {
    //Remove last character
    formattedPhoneNumber = formattedPhoneNumber.slice(0, -1);
  }

    return formattedPhoneNumber;
}

export const formatDate = (date, formatOfDate) => {
    try {
        if (!formatOfDate) formatOfDate = "MM/dd/yyyy";
        const dateParsed = parseISO(date);
        const formatedDate = format(dateParsed, formatOfDate);
        return formatedDate;

    } catch {
        return "";
    }
};



export const formatPhoneFromNonIntegers = (phoneNumber) => {
  //Replace all non integers from phoneNumber
  if(phoneNumber)
    phoneNumber = phoneNumber.replace("(", "").replace(")", "").replace("-", "").replace(" ", "").replace(".", "").replace("+", "");
  else
    phoneNumber = "";

return phoneNumber;
}

export const calculateDateDiff = (date) => {
    const today = new Date();

    const isoDate = parseISO(date);

    let yearsDiff = differenceInYears(today, isoDate);
    let monthsDiff = differenceInMonths(today, isoDate) % 12;

    return { yearsDiff, monthsDiff  };
};
export function RelativeTime({ dateStr }) {
    try {
        const date = getLocalDateTime(dateStr);
        const timeAgo = formatDistanceToNowStrict(date, { addSuffix: true });

        const formattedTime = timeAgo
            .replace(/( hours| hour)/, 'h')
            .replace(/( minutes| minute)/, 'm')
            .replace(/( seconds| second)/, 's')
            .replace(/( days| day)/, 'd')
            .replace(/( months| month)/, 'mo')
            .replace(/( years| year)/, 'y');

        return formattedTime;

    } catch {
        return "";
    }
}
function getLocalDateTime(utcDateTimeString) {
    const utcDateTime = new Date(utcDateTimeString);

    // Get the local date and time
    const localDateTime = new Date(utcDateTime);
    const offset = localDateTime.getTimezoneOffset();
    localDateTime.setMinutes(localDateTime.getMinutes() - offset);

    return localDateTime;
}